import { render } from "./Crimes.vue?vue&type=template&id=fa0ea8ba"
import script from "./Crimes.vue?vue&type=script&lang=js"
export * from "./Crimes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__